import { Button, Box, Card, CardActions, CardContent, Container, Link as MuiLink, Typography } from "@mui/material";
import WarningIcon from '@mui/icons-material/Warning';
import { CONTACT_URL } from "../../constants";
import { Link } from "react-router-dom";

export default function CheckoutCanceled() {
  return (
    <Container sx={{ p: 3 }} maxWidth="md">
      <Card>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center' }}>
            <WarningIcon sx={{ fontSize: 72 }} color="secondary" />
          </Box>
          <Typography sx={{ textAlign: 'center', mt: 2 }} variant="h3">
            Checkout was canceled
          </Typography>
          <Typography sx={{ textAlign: 'center', mt: 2 }}>
            Return to OpenGolfSim to restart your purchase
          </Typography>
        </CardContent>
        <CardActions sx={{ justifyContent: 'center' }}>
          <Button color="secondary" href={CONTACT_URL} target="_blank" variant="outlined">Contact Support</Button>
          <Button component={Link} to="/account" variant="outlined">My Account</Button>
        </CardActions>
      </Card>
    </Container>
  );
}